import React from 'react'
import { Loader } from 'goustouicomponents'
import css from './ContentLoader.module.css'

const ContentLoader = () => <div className={css.wrapper}><Loader color="Bluecheese" /></div>

export { ContentLoader }
